<template>
  <div>
    <div class="headerCate">
      <h1>{{ $t('marketplace.label.listSubCategory.title') }}</h1>

      <v-data-table 
        :headers="headers" 
        :items="subcategorias"
        :header-props="{ class: 'red-header' }"
        :search="searchTerm"
        :no-data-text="$t('chart.label.notData') || 'No hay datos disponibles'"
        :footer-props="{ 'items-per-page-text': $t('label.rowsPerPage.title') }"
      >

        <!-- Sección superior de la tabla -->
        <template v-slot:top>
          <div style="margin-bottom: 50PX;">
            <!-- Barra de búsqueda y botón de agregar -->
            <div class="row justify-space-between mx-auto">
              <v-text-field
                :label="$t('label.search.title')"
                :placeholder="$t('label.search.text')"
                append-icon="mdi-magnify"
                dense
                outlined
                color="primary"
                class="col-md-5"
                @input="search"
              ></v-text-field>

              <div class="btn">
                <addSubcategoriaMarketplace 
                :category="category"
                />
              </div>
            </div>
          </div>
        </template>

        <template v-slot:[`item.nombreTipoProducto`]="{ item }">
          <span class="custom-font">{{ item.nombreTipoProducto }}</span>
        </template>

        <template v-slot:[`item.descripcion`]="{ item }">
          <span class="custom-font">{{ item.descripcion }}</span>
        </template>

        <template v-slot:[`item.nombreCategoria`]="{ item }">
          <span class="custom-font">{{ item.nombreCategoria }}</span>
        </template>

        <template v-slot:[`item.action`]="{ item }">
        <!-- Botón de acción para abrir el diálogo de detalles  -->
        <v-icon
        color="primary"
        @click.stop="setActiveDialog({ status: true, index: item.index })"
        ></v-icon
        >
        <div class="actions">

          <detailsSubcategory
            :status="item.activeDialogClient"
            :subcategoryProps="item"
            style="margin-left:1vh"
            @close="setActiveDialog({ status: false, index: item.index })"
          />
          <v-btn
            class="btnDetails"
            icon    
            x-large
            dark
            text
            @click = "deleteSubCategorie(item.idTipoProducto)"
            style="background-color: transparent; margin-left:1vh"
          >
            <v-icon color="primary">mdi-delete</v-icon>
          </v-btn>
        </div>
      </template>

      </v-data-table>

    </div>
  </div>
</template>
  
<script>
    import addSubcategoriaMarketplace from "@/views/categories_marketplace/pages/add_subcategories_marketplace/add_subcategories_marketplace_page.vue";
    import detailsSubcategory from "@/views/categories_marketplace/pages/detail_subcategories_marketplace/detail_marketplace_page.vue";
    import Swal from "sweetalert2";
    import  EventBus  from '@/utils/event_bus.js';
    import { mapActions, mapGetters } from "vuex";
    import {
      MARKETPLACE_M,
      GET_SUBCATEGORIES_MARKETPLACE,
      ACTION_GET_SUBCATEGORIES_MARKETPLACE,
      ACTION_DELETE_DELETE_SUBCATEGORIES_MARKETPLACE
    } from "@/views/categories_marketplace/store/types/types.js";
    import i18n from '@/plugins/i18n';

    export default {

      name: "listSubcategoriaComponent",
      components: {
        addSubcategoriaMarketplace,
        detailsSubcategory
      },
      props: {
        category: {
          required: true
        },
      },

      data() {
        return {
          searchTerm: "",
        };
      },

      mounted() {
        try {
          this.getActionsubcategories(this.category.idCategoriaComercial);
          this.$forceUpdate();
        } catch (error) {
          Swal.fire({
            icon: 'error',
            title: i18n.t('label.invalid.title'),
            text: i18n.t('label.errorGetSubCategories'),
          });
        } 

        EventBus.$on('reload-subcategories-marketplace', async () => {
          await this.reloadSubcategoriesMarketplace();
        });

        EventBus.$on('formSubMarketplace-submitted-successfully', async () => {
          await this.reloadSubcategoriesMarketplace();
        });

        EventBus.$on('update-subcategorie-marketplace', async () => {
          await this.reloadSubcategoriesMarketplace();
        });

        EventBus.$on('reload-delete-submarketplace', async () => {
          await this.reloadSubcategoriesMarketplace();
        }); 
        
        EventBus.$on('reload-create-submarketplace', async () => {
          await this.reloadSubcategoriesMarketplace();
        });

        EventBus.$on('reload-update-categoriesMarketplace-sub', async () => {
          await this.reloadSubcategoriesMarketplace();
        });

      },

      methods: {
        
        ...mapActions({
          getActionsubcategories: `${MARKETPLACE_M}${ACTION_GET_SUBCATEGORIES_MARKETPLACE}`,
          deleteActionSubCategories: `${MARKETPLACE_M}${ACTION_DELETE_DELETE_SUBCATEGORIES_MARKETPLACE}`,
        }),

        async reloadSubcategoriesMarketplace() {
          await this.getActionsubcategories(this.category.idCategoriaComercial);
        },

        search() {
          // Actualiza el término de búsqueda
          this.searchTerm = event.target.value;
        },

        async deleteSubCategorie(idTipoProducto) {
            const result = await Swal.fire({
              title: i18n.t('label.delete.title'),
              text: i18n.t('label.delete.text'),
              icon: "question",
              showCancelButton: true,
              confirmButtonText: i18n.t('button.delete.accept'),
              cancelButtonText: i18n.t('button.delete.cancel'),
              confirmButtonColor: "#6E17A5",
            });

            if (result.isConfirmed) {
              try {
                this.deleteActionSubCategories(idTipoProducto);
                
                this.reloadSubcategoriesMarketplace();
                this.$forceUpdate();
             
              } catch (error) {
               console.error(error)
              }
            } else {
              Swal.fire({
                position: 'top-end',
                icon: 'info',
                title: i18n.t('label.delete.cancel'),
                showConfirmButton: false,
                timer: 2500
              });
            }
        },

      },

      computed: {
        ...mapGetters({
          subcategorias: [`${MARKETPLACE_M}${GET_SUBCATEGORIES_MARKETPLACE}`],
        }),

        headers() {
          return [
            {
              text: this.$t('marketplace.label.table.nameSubCategory'),
              value: "nombreTipoProducto",
              align: "center",
              sortable: false,
              class: "primary--text text-h1 text-md-h5 text-lg-h5 font-weight-medium text-subtitle-1",
            },
            {
              text: this.$t('marketplace.label.table.description'),
              value: "descripcion",
              align: "center",
              sortable: false,
              class: "primary--text text-h1 text-md-h5 text-lg-h5 font-weight-medium text-subtitle-1",
            },
            {
              text: this.$t('marketplace.label.table.nameCategory'),
              value: "nombreCategoria",
              align: "center",
              sortable: false,
              class: "primary--text text-h1 text-md-h5 text-lg-h5 font-weight-medium text-subtitle-1",
            },
            {
              value: "action",
              sortable: false,
              align: "left",
              //class: "primary--text mdi-pencil text-subtitle-1 ",
            },
          ];
        },
      },

    };
  
</script>
  
<style scoped>
  
  .headerCate h1 {
    margin-bottom: 55px;
  }

  .actions v-icon {
    font-size: 24px;
  }


  .custom-font {
    font-size: 20px;
  }

  /* Define los estilos (Tipo de letra) para las etiquetas h1,h2,h3,h4,h5,h6   */
  body {
    font-family: 'Nunito Sans', sans-serif;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: 'Amsi Pro',  sans-serif;
    color: #2D0049;
    font-weight: normal;
  }

   /* Estilos para el botón de eliminar */
   .btnDetails .v-icon {
    color: #6E17A5;
    margin-bottom: 19px;
  }

  .actions{
    display:flex
  }



</style>
  
  
  
  
    
     
  
      
        
  
        
  
  
  
  
  